module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/notifications-0639c6f5d1b119fe8d51229a672d6842.jpg";